export const movies4youData = {
    designs: {
        title: 'High-fidelity designs',
        images: {
            mobile: [
                'movies4you_mobile_1.png',
                'movies4you_mobile_2.png',
                'movies4you_mobile_3.png',
                'movies4you_mobile_4.png',
                'movies4you_mobile_5.png',
                'movies4you_mobile_6.png',
                'movies4you_mobile_7.png',
                'movies4you_mobile_8.png',
                'movies4you_mobile_9.png'
            ]
        }
    }
}
